import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { connectUserHeaderinfo } from '../Auth/WithUserHeaderInfo';
import { withCurrency } from '../Common/Providers/WithCurrency';
import { roundCurrency } from '../Common/Helper';
import config from '../../config';
import { HTMLTrans } from '../Common/Translations';

export const icon = `${config.s3BucketUrl}/gift_card/redeemGCSuccess.svg`;

class SuccessRedeemBody extends PureComponent {
  render() {
    const {
      giftCardValue,
      closeCallback,
      currency,
      userHeaderInfo: {
        creditBalance
      }
    } = this.props;
    const creditDisplay = `${currency} ${roundCurrency(creditBalance)}`;
    const giftCardValueDisplay = `${currency} ${roundCurrency(giftCardValue)}`;
    return (
      <div>
        <img src={icon}></img>
        <p><HTMLTrans id="footer.giftcardcredit_successredeem_body" variables={{"giftCardValueDisplay": giftCardValueDisplay}}>{`Your ${giftCardValueDisplay} Credit Redeem was Successful.
        You now have credit balance of`}</HTMLTrans></p>
        <h1>{creditDisplay}</h1>
        <button
          className='btn btn-secondary'
          onClick={closeCallback}
          ><HTMLTrans id="footer.giftcardcredit_successredeem_oh_button">OK</HTMLTrans>
        </button>
      </div>
    );
  }
}

const enhance = compose(
  connectUserHeaderinfo,
  withCurrency,
);

export default enhance(SuccessRedeemBody);
export const undecorated = SuccessRedeemBody;



// WEBPACK FOOTER //
// ./src/GiftCardCredit/SuccessRedeemBody.js